<template>
    <RegisterStep
        :ready="ready"
        :loading="loading"
        :previous-route="previousRoute"
        v-bind="$attrs"
        @submit="handleStepSubmitted"
    >
        <template v-slot:title>
            Formulaire de confirmation de candidature
        </template>

        <SingleForm
            :order="currentOrder"
            :course="course"
            :loading="loading"
            confirmation-form
            ref="form"
        />
    </RegisterStep>
</template>

<script>
    import clone from 'lodash/clone';
    import RegisterStep from "../RegisterStep";
    import { postOrderConfirmationForm } from "../../../api";
    import SingleForm from "./form/SingleForm";

    export default {
        components: {
            SingleForm,
            RegisterStep,
        },
        props: {
            order: Object,
            course: Object,
            nextRoute: Object,
            previousRoute: Object,
        },
        data() {
            return {
                ready: false,
                currentOrder: clone(this.order),
                errors: null,
                loading: false,
            }
        },
        methods: {
            async handleStepSubmitted() {
                this.loading = true;

                const formojResponse = await this.$refs.form.submit({ showSuccess:false })
                    .catch(e => {
                        this.loading = false;
                        return Promise.reject(e);
                    });
                this.currentOrder.registrants = [
                    {
                        ...this.currentOrder.registrants[0],
                        confirmation_answer_id: formojResponse.answer_id,
                    }
                ]

                const { courseId, sessionId, orderId } = this.$route.params;
                this.errors = null;
                postOrderConfirmationForm({ courseId, sessionId, orderId, data:this.currentOrder })
                    .then(order => {
                        this.currentOrder = order;
                        this.$emit('update:order', order);
                        this.$router.push(this.nextRoute);
                    })
                    .catch(error => {
                        if(error.response?.status === 422) {
                            this.errors = error.response.data.errors;
                        }
                        return Promise.reject(error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            init() {
                this.ready = true;
            },
        },
        created() {
            this.init();
        },
    }
</script>
